(function () {
  const initGoogleMaps = () => {
    const mapContainers = Array.from(document.querySelectorAll('[data-map]')).filter(
      (container) => container.getAttribute('data-has-key') === 'true'
    );
    if (!mapContainers.length) return;

    const initMap = (mapContainer) => {
      const locationsRaw = mapContainer.getAttribute('data-map-locations') || '[]';
      let locations = [];
      try {
        locations = JSON.parse(locationsRaw);
      } catch (_error) {
        locations = [];
      }
      if (!locations.length) return;

      const zoom = parseInt(mapContainer.getAttribute('data-map-zoom'), 10) || 13;
      const mapType = mapContainer.getAttribute('data-map-type') || 'roadmap';
      const markerUrl = mapContainer.getAttribute('data-map-marker');
      let styleJson = null;
      const customStyle = mapContainer.getAttribute('data-map-style');

      if (customStyle) {
        try {
          styleJson = JSON.parse(customStyle);
        } catch (_error) {
          styleJson = null;
        }
      }

      const center = {
        lat: locations[0].lat,
        lng: locations[0].lng,
      };

      const map = new google.maps.Map(mapContainer, {
        center,
        zoom,
        mapTypeId: mapType,
        styles: styleJson || null,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
      });

      const bounds = new google.maps.LatLngBounds();
      const infoWindow = new google.maps.InfoWindow();

      locations.forEach((location) => {
        const position = {
          lat: location.lat,
          lng: location.lng,
        };

        const marker = new google.maps.Marker({
          position,
          map,
          icon: markerUrl || null,
        });

        bounds.extend(position);

        const hasInfo =
          location.title || location.address || location.info_text || (location.link && location.link.url);

        if (hasInfo) {
          marker.addListener('click', () => {
            const linkHtml =
              location.link && location.link.url
                ? `<a href="${location.link.url}" target="${location.link.target || '_self'}" class="mt-2 inline-flex items-center gap-2 text-sm font-semibold text-primary">${location.link.title || 'Route'} <span aria-hidden="true">&rarr;</span></a>`
                : '';

            infoWindow.setContent(
              `<div class="p-2 text-sm text-gray-700">${
                location.title ? `<div class="font-semibold text-gray-900">${location.title}</div>` : ''
              }${
                location.address ? `<div class="mt-1">${String(location.address).replace(/\\n/g, '<br>')}</div>` : ''
              }${location.info_text ? `<div class="mt-2">${location.info_text}</div>` : ''}${linkHtml}</div>`
            );
            infoWindow.open(map, marker);
          });
        }
      });

      if (locations.length > 1) {
        map.fitBounds(bounds);
      }
    };

    const initAllMaps = () => {
      mapContainers.forEach((container) => {
        if (container.dataset.mapInitialized === 'true') return;
        container.dataset.mapInitialized = 'true';
        initMap(container);
      });
    };

    if (window.google && window.google.maps) {
      initAllMaps();
      return;
    }

    const existingScript = document.querySelector('script[data-google-maps]');
    if (existingScript) {
      existingScript.addEventListener('load', initAllMaps);
      return;
    }

    const apiKey = mapContainers[0]?.getAttribute('data-map-api-key') || '';
    if (!apiKey) return;

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly`;
    script.async = true;
    script.defer = true;
    script.dataset.googleMaps = 'true';
    script.addEventListener('load', initAllMaps);
    document.head.appendChild(script);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGoogleMaps);
  } else {
    initGoogleMaps();
  }
})();
